(function initShopTheLookDrawer() {
    if (window.ShopTheLook) return; 
  
    const drawer = document.querySelector('.lookbook-shop-the-look-drawer[data-store-availability-drawer]');
    if (!drawer) {
      window.ShopTheLook = { open: () => {}, isReady: false };
      return;
    }
  
    const container = drawer.querySelector('[data-store-list-container]');
    const wash = drawer.querySelector('[data-store-availability-drawer-wash]');
    const closeBtn = drawer.querySelector('[data-store-availability-close]');
    const ACTIVE = 'active';
  
    const hasAnimate = typeof window.shouldAnimate === 'function' && window.shouldAnimate(drawer);
    const animator = hasAnimate && typeof window.animateStoreAvailabilityDrawer === 'function'
      ? window.animateStoreAvailabilityDrawer(drawer)
      : null;
  
    const focusTrap = typeof window.createFocusTrap === 'function'
      ? window.createFocusTrap(drawer, { allowOutsideClick: true })
      : null;
  
    function open() {
      drawer.classList.add(ACTIVE);
      drawer.setAttribute('aria-hidden', 'false');
      if (animator && animator.animate) animator.animate();
  
      if (focusTrap) focusTrap.activate();
      if (typeof window.disableBodyScroll === 'function') {
        window.disableBodyScroll(drawer, { reserveScrollBarGap: true });
      }
      document.body.setAttribute('data-fluorescent-overlay-open', 'true');
    }
  
    function close() {
      if (focusTrap) focusTrap.deactivate();
      drawer.classList.remove(ACTIVE);
      drawer.setAttribute('aria-hidden', 'true');
  
      setTimeout(() => {
        if (animator && animator.reset) animator.reset();
        if (typeof window.enableBodyScroll === 'function') {
          window.enableBodyScroll(drawer);
        }
        document.body.setAttribute('data-fluorescent-overlay-open', 'false');
      }, 500);
    }
  
    wash?.addEventListener('click', close);
    closeBtn?.addEventListener('click', close);
    drawer.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
  
    window.ShopTheLook = {
      isReady: true,
      /**
       * @param {Array<{id:number,title:string,price:number,image:string,url:string}>} products
       */
      open(products) {
        if (!Array.isArray(products)) products = [];
        if (!products.length) {
          container.innerHTML = '<p class="lb-empty">No items in this look.</p>';
        } else {
          const items = products.map(p => {
            const title = lbEscapeHtml(p.title || '');
            const price = lbFormatMoney(p.price || 0);
            const url = typeof p.url === 'string' ? p.url : '#';
            const img = typeof p.image === 'string' ? p.image : '';
            const imgTag = img ? `<img src="${lbEscapeHtml(img)}" alt="${title}">` : '';
  
            return `
              <li class="lb-shop-card">
                <a class="lb-shop-thumb" href="${lbEscapeHtml(url)}">
                  ${imgTag}
                </a>
                <div class="lb-shop-meta">
                  <span class="lb-shop-title">${title}</span>
                  <span class="lb-shop-price">${price}</span>
                </div>
              </li>
            `;
          }).join('');
  
          container.innerHTML = `<ul class="lb-shop-grid">${items}</ul>`;
        }
  
        open();
      },
      close
    };
  })();


function lbEscapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
}
  
function lbFormatMoney(cents) {
    try {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        const fmt = (window.Shopify.money_format || window.theme?.moneyFormat || '${{amount}}');
        return window.Shopify.formatMoney(cents, fmt);
        }
        const currency = window.Shopify?.currency?.active || document.documentElement.getAttribute('data-shop-currency') || 'USD';
        return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
    } catch(e) {
        return (Number(cents) / 100).toFixed(2);
    }
}
  
function lbReadProductsFromItem(itemEl) {
    const labelEl = itemEl.querySelector('[data-lookbook-products]');
    const fromLabel = labelEl?.getAttribute('data-lookbook-products');
    if (fromLabel) {
        try { return JSON.parse(fromLabel); } catch (e) { console.warn('Bad lookbook JSON on label', e); }
    }
    const fromItem = itemEl.getAttribute('data-lookbook-products');
    if (fromItem) {
        try { return JSON.parse(fromItem); } catch (e) { console.warn('Bad lookbook JSON on item', e); }
    }

    const legacy = itemEl.getAttribute('data-products-id');
    if (legacy) {
        try {
        let str = legacy.trim();
        if (!str.startsWith('[')) str = '[' + str + ']';
        str = str.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/'/g, '"');
        return JSON.parse(str);
        } catch(e) { console.warn('Failed to parse legacy products payload', e); }
    }

    return [];
}
  
  